<template>
  <div class="homePage">
    <div class="upperHeader">
      <div class="logo">
        <img src="../assets/logo.png" alt="logo" class="logoImg" />
      </div>
      <div class="service">
        <p>SERVICE PROVIDED</p>
        <p>Calgary</p>
      </div>
      <div class="hours">
        <p>BUSINESS HOURS:</p>
        <p>8am - 6pm</p>
      </div>
      <div class="contact">
        <p>EMAIL:</p>
        <p>info@intextelectric.ca</p>
      </div>
      <div class="mapLogo" @click="popup">
        <img
          src="../assets/speacial.png"
          alt="promotion"
          width="90px"
          height="80px"
          class="speacial"
        />
      </div>
      <div id="popup2" class="overlay2">
        <div class="popup2">
          <a class="close" id="close" @click="close">&times;</a>
          <div class="content">
            <h1>Get your FREE Electrical Maintenance report!</h1>
            <p>
              Only this month we will provide a free maintenance report on your
              residential and commercial properties. We will inspect your
              property and provide a comprehensive list of potential hazards as
              well as recommendations on how to decrease your electrical bill.
              DO NOT miss the opportunity and order your FREE property
              inspection TODAY!
            </p>
          </div>
        </div>
      </div>
    </div>
    <div id="mainHeader" class="mainHeader" :class="{ sticky: scroll }">
      <div class="nav">
        <router-link class="link" to="/">HOME</router-link>
        <router-link class="link" to="/residential"
          >RESIDENTIAL SERVICES</router-link
        >
        <router-link class="link" to="/commercial"
          >COMMERCIAL SERVICES</router-link
        >
        <router-link class="link" to="/projects">PROJECTS</router-link>
        <router-link class="link" to="/contact">CONTACT</router-link>
      </div>
      <div id="menu" :class="{ active: Menu }">
        <div class="sandwich" @click.prevent="toggle">
          <div class="sandwichMenu1" />
          <div class="sandwichMenu2" />
          <div class="sandwichMenu3" />
        </div>
        <div class="SBox">
          <router-link class="SBoxLink" to="/"
            ><span @click="toggle">HOME</span></router-link
          >
          <router-link class="SBoxLink" to="/residential"
            ><span @click="toggle">RESIDENTIAL SERVICES</span>
          </router-link>
          <router-link class="SBoxLink" to="/commercial"
            ><span @click="toggle">COMMERCIAL SERVICES</span>
          </router-link>
          <router-link class="SBoxLink" to="/projects"
            ><span @click="toggle">PROJECTS</span></router-link
          >
          <router-link class="SBoxLink" to="/contact"
            ><span @click="toggle">CONTACT</span></router-link
          >
        </div>
      </div>
      <div id="phone" class="phone">
        <a href="tel:+15879695387" style="text-decoration:none; color:white"
          ><img
            src="../assets/phone-volume-solid.svg"
            alt="call us"
            class="callIcon"
        /></a>

        <h6>
          <a href="tel:+15879695387" style="text-decoration:none; color:white"
            >(587) 969-5387
          </a>
        </h6>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      Menu: false,
      scroll: false,
    };
  },
  methods: {
    toggle() {
      let box = document.getElementById("mainHeader");
      let phone = document.getElementById("phone");
      this.Menu = !this.Menu;
      if (this.Menu) {
        box.style.height = "400px";
        phone.style.flex = 1;
      } else {
        box.style.height = "100px";
        phone.style.flex = 2;
      }
    },
    popup() {
      var modal = document.getElementById("popup2");
      let menu = document.getElementsByClassName("mainHeader")[0];
      menu.style.zIndex = -5;
      modal.style.visibility = "visible";
      console.log("Open");
    },
    close() {
      var modal = document.getElementById("popup2");
      let menu = document.getElementsByClassName("mainHeader")[0];
      menu.style.zIndex = 5;
      modal.style.visibility = "hidden";
      console.log("Closed");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/main.scss";

.mainHeader {
  animation: fadeInAnimation ease 0.5s;
  animation-iteration-count: 1;
  animation-fill-mode: forwards;
  position: relative;
  z-index: 5;
  display: flex;
  width: 100%;
  height: 65px;
  background-color: rgba(0, 0, 0, 0.87);
}

.popup2 {
  background: linear-gradient(rgb(255, 255, 255), rgba(255, 255, 255, 0.801)),
    url("../assets/background.jpg");
  background-repeat: no-repeat;
  background-size: contain;
  background-position: 0 180px;
  background-color: white;
  z-index: 20;
  border: 4px solid #013170;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 70px auto;
  padding: 20px;
  border-radius: 8px;
  width: 60%;
  height: 700px;
  position: relative;

  h1 {
    text-align: center;
    margin-top: 200px;
    color: red;
    font-size: 40px;
  }

  p {
    text-align: center;
    margin-top: 50px;
    font-weight: bold;
    font-size: 24px;
    width: 70%;
    margin-left: 15%;
  }
}

.overlay2 {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.9);
  z-index: 15;
  visibility: hidden;
  opacity: 1;
}

.popup2 h2 {
  margin-top: 0;
  color: #333;
}

.popup2 .close {
  position: absolute;
  top: 20px;
  right: 30px;
  font-size: 50px;
  font-weight: bold;
  text-decoration: none;
  color: rgb(0, 0, 0);
}

.popup2 .close:hover {
  cursor: pointer;
  color: rgba(255, 0, 0, 0.849);
}

.popup2 .content {
  max-height: 95%;
  overflow: auto;
}

.upperHeader {
  background-position: center 0px;
  background-size: cover;
  background-repeat: no-repeat;
  animation: fadeInAnimation ease 0.5s;
  animation-iteration-count: 1;
  animation-fill-mode: forwards;
  width: 100%;
  height: 120px;
  display: flex;
  flex-direction: row;
  font-size: 18px;
}

.logo {
  flex: 3;
  display: flex;
}

.mapLogoSVG {
  align-self: center;
}

.logoImg {
  align-self: center;
  width: 170px;
  height: 170px;
  margin-left: 40px;
}

.service {
  margin: auto;
  flex: 5;
  margin-left: 2%;
}

.hours {
  flex: 5;
  margin: auto;
}

.contact {
  flex: 5;
  margin: auto;
}

.mapLogo {
  display: flex;
  flex: 2;
  cursor: pointer;

  img {
    margin-top: 20px;
    animation: special 3s linear infinite;
    transform-origin: center bottom;
  }
}

.phone {
  flex: 1;
  display: flex;
  background-color: #fd6c0be1;
  align-items: center;
  justify-content: center;

  h6 {
    color: white;
    font-size: 22px;
  }

  .callIcon {
    padding-right: 15px;
    width: 20px;
  }
}

.nav {
  flex: 4;
  display: flex;
}

.link {
  color: white;
  text-decoration: none;
  font-weight: bold;
  margin: auto;
}

.link:hover {
  transition: 0.5s;
  color: #ff6700;
}

@keyframes fadeInAnimation {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

.sandwichMenu {
  display: none;
}

.SBoxLink {
  display: none;
}

.sticky {
  position: fixed;
  top: 0;
}

@media only screen and (max-width: 500px) {
  .hours {
    display: none;
  }
}

@media only screen and (max-width: 900px) {
  .popup2 {
    width: 80%;
    height: 600px;

    p {
      font-size: 20px;
      width: 90%;
      margin-left: 5%;
    }

    h1 {
      margin-top: 45px;
      font-size: 30px;
    }
  }

  .service {
    font-size: 16px;
    flex: 3;
  }

  .hours {
    font-size: 16px;
    flex: 3;
  }

  .logoImg {
    align-self: center;
    width: 140px;
    height: 120px;
    margin-left: 10px;
  }

  .mainHeader {
    flex-direction: column;
    height: 100px;
  }

  .phone {
    flex: 4;
  }

  .nav {
    display: none;
  }

  #menu.active .SBox {
    display: flex;
    width: 80%;
    margin-top: 30px;
  }

  #menu {
    width: 100%;
    cursor: pointer;
    flex: 3;
    display: flex;
    align-items: center;
    margin-top: 3px;
  }

  #menu.active {
    flex-direction: column;
  }

  #menu.active .sandwich {
    margin-top: 10px;
    margin-left: 0%;
    transform: translateX(0%);
  }

  .sandwich {
    margin-left: 50%;
    transform: translateX(-50%);
  }

  .sandwichMenu1,
  .sandwichMenu2,
  .sandwichMenu3 {
    transition: 0.4s;
    display: block;
    width: 45px;
    height: 5px;
    background-color: white;
    margin: 5px 0;
  }

  #menu.active .sandwichMenu1 {
    transform: rotate(-45deg) translate(-9px, 6px);
  }

  #menu.active .sandwichMenu2 {
    opacity: 0;
  }

  #menu.active .sandwichMenu3 {
    transform: rotate(45deg) translate(-8px, -8px);
  }

  .SBox {
    display: none;
    height: 200px;
    flex-direction: column;
  }

  #menu.active .SBoxLink {
    flex: 1;
    flex-direction: column;
    display: block;
    color: white;
  }

  .contact {
    display: none;
  }
}

@keyframes special {
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.93);
  }

  100% {
    transform: scale(1);
  }
}
</style>
